"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _includes = _interopRequireDefault(require("lodash/fp/includes"));
var _rxjs = require("rxjs");
var _constants = require("../constants");
var _comboBoxBase = _interopRequireWildcard(require("./comboBoxBase"));
var _focusUtils = require("./focusUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function useComboBox(_ref) {
  var comboBoxRef = _ref.comboBoxRef,
    disabled = _ref.disabled,
    listBoxRef = _ref.listBoxRef,
    focusListBoxSignal = _ref.focusListBoxSignal,
    signalFocusListBox = _ref.signalFocusListBox,
    listBoxCollapseSubject = _ref.listBoxCollapseSubject,
    changeExpandedStatus = _ref.changeExpandedStatus;
  var handleComboBoxKeyDown = _react["default"].useCallback(function (e) {
    if (!(0, _includes["default"])(e.key)([_constants.KEY_VALUES.UPARROW, _constants.KEY_VALUES.DOWNARROW])) {
      return;
    }
    if (disabled) {
      return;
    }
    e.preventDefault();
    changeExpandedStatus === null || changeExpandedStatus === void 0 || changeExpandedStatus(true);
    signalFocusListBox === null || signalFocusListBox === void 0 || signalFocusListBox((0, _comboBoxBase.createSignal)());
  }, [disabled, signalFocusListBox, changeExpandedStatus]);
  _react["default"].useEffect(function handleFocusListBoxSignal() {
    if ((0, _comboBoxBase.signaled)(focusListBoxSignal) && listBoxRef !== null && listBoxRef !== void 0 && listBoxRef.current) {
      (0, _focusUtils.emitFocusListBoxItem)(listBoxRef.current);
    }
  }, [listBoxRef, focusListBoxSignal]);
  _react["default"].useEffect(function handleComponentFocus() {
    var comboBox = comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current;
    if (!comboBox) {
      return undefined;
    }
    var comboBoxFocus$ = (0, _rxjs.fromEvent)(comboBox, 'focus');
    var componentFocus$ = (0, _comboBoxBase.getComponentFocusObservable)({
      comboBoxFocus$: comboBoxFocus$,
      listBoxCollapse$: listBoxCollapseSubject.current
    }).subscribe(function () {
      if (!disabled) {
        changeExpandedStatus === null || changeExpandedStatus === void 0 || changeExpandedStatus(true);
      }
    });
    return function () {
      componentFocus$.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comboBoxRef, comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current, changeExpandedStatus]);
  _react["default"].useEffect(function addEventListeners() {
    var comboBox = comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current;
    comboBox === null || comboBox === void 0 || comboBox.addEventListener('keydown', handleComboBoxKeyDown);
    return function () {
      comboBox === null || comboBox === void 0 || comboBox.removeEventListener('keydown', handleComboBoxKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comboBoxRef, comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current, handleComboBoxKeyDown, listBoxRef, listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current]);
}
var _default = exports["default"] = (0, _comboBoxBase["default"])(useComboBox);